import { render, staticRenderFns } from "./inspectionUserStatistics.vue?vue&type=template&id=7afe00e5&scoped=true&"
import script from "./inspectionUserStatistics.vue?vue&type=script&lang=js&"
export * from "./inspectionUserStatistics.vue?vue&type=script&lang=js&"
import style0 from "./inspectionUserStatistics.vue?vue&type=style&index=0&id=7afe00e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afe00e5",
  null
  
)

export default component.exports